<template>
  <div class="ab-industry-list">
    <AbBlock title="覆盖全行业品类" subTitle="细分化赋能行业破圈">
      <a-row>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_1.png" />工业与机械
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">工业与机械</div>

            <p class="fontsize16"><i></i> 制造服务</p>
            <p class="fontsize16"><i></i> 机械设备</p>
            <p class="fontsize16"><i></i> 电气设备</p>
            <p class="fontsize16"><i></i> 消防设备</p>
            <p class="fontsize16"><i></i> 五金元件</p>
            <p class="fontsize16"><i></i> 仓储设备</p>
            <p class="fontsize16"><i></i> 工具零件</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_2.png" />电子元器件
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">电子元器件</div>
            <p class="fontsize16"><i></i> 消费电子</p>
            <p class="fontsize16"><i></i> 数码配件</p>
            <p class="fontsize16"><i></i> 家用电器</p>
            <p class="fontsize16"><i></i> 电子元器件</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_9.png" />母婴及玩具
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">母婴及玩具</div>
            <p class="fontsize16"><i></i> 母婴产品</p>
            <p class="fontsize16"><i></i> 儿童玩具</p>
            <p class="fontsize16"><i></i> 礼品套装</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_3.png" />家居日用品
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">家居日用品</div>
            <p class="fontsize16"><i></i> 纺织面料</p>
            <p class="fontsize16"><i></i> 家具</p>
            <p class="fontsize16"><i></i> 家居用品</p>
            <p class="fontsize16"><i></i> 灯光照明</p>
            <p class="fontsize16"><i></i> 综合百货</p>
            <p class="fontsize16"><i></i> 休闲宠物</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_4.png" />货运及汽车
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">货运及汽车</div>
            <p class="fontsize16"><i></i> 货运交通</p>
            <p class="fontsize16"><i></i> 汽车</p>
            <p class="fontsize16"><i></i> 配件</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_1.png" />健康与美容
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">健康与美容</div>
            <p class="fontsize16"><i></i> 个人护理</p>
            <p class="fontsize16"><i></i> 医疗用品</p>
            <p class="fontsize16"><i></i> 医疗设备</p>
            <p class="fontsize16"><i></i> 美容产品</p>
            <p class="fontsize16"><i></i> 美容仪器</p>
            <p class="fontsize16"><i></i> 安全防护</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_6.png" />建筑及装饰
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">建筑及装饰</div>
            <p class="fontsize16"><i></i> 装修辅材</p>
            <p class="fontsize16"><i></i> 装饰材料</p>
            <p class="fontsize16"><i></i> 工艺装饰</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_5.png" />服装与配饰
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">服装与配饰</div>
            <p class="fontsize16"><i></i> 服装</p>
            <p class="fontsize16"><i></i> 包包</p>
            <p class="fontsize16"><i></i> 帽子</p>
            <p class="fontsize16"><i></i> 时尚配饰</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_7.png" />包装与办公
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">包装与办公</div>
            <p class="fontsize16"><i></i> 印刷包装</p>
            <p class="fontsize16"><i></i> 办公用品</p>
          </div>
        </a-col>
        <a-col :xs="24" :xl="5">
          <div class="item-industry fontsize26">
            <img src="~@/assets/home/pic_f_8.png" />化工与能源
          </div>
          <div class="hover-item-industry">
            <div class="fontsize26">化工与能源</div>
            <p class="fontsize16"><i></i> 化学品</p>
            <p class="fontsize16"><i></i> 光学零件</p>
            <p class="fontsize16"><i></i> 橡胶材料</p>
            <p class="fontsize16"><i></i> 矿产能源</p>
          </div>
        </a-col>
      </a-row>
    </AbBlock>
  </div>
</template>

<script>
import AbBlock from "@/components/AbBlock.vue";
export default {
  components: {
    AbBlock,
  },
};
</script>

<style lang="sass" scoped>
.ab-industry-list{
.ant-row{
  margin:50px 0px;  border:1px solid #D6EAFF;
  border-bottom:none;

}
.ant-col-xl-5:hover .hover-item-industry{
  cursor: pointer;
  display: block;

}
.ant-col-xl-5:nth-child(-n+5) .hover-item-industry{
 bottom:-180px;
}
  .hover-item-industry{
   display: none;
    .fontsize16{
      padding:0px 0px 0px 90px;
      margin-bottom:6px;
      i{
        width: 8px;
        height: 8px;
        background: #FFFFFF;
        display: inline-block;
        margin-right:7px;
        border-radius: 50%;
        top: -2px;
        position: relative;
      }
    }
    .fontsize26{
      padding:50px 0px 40px 90px;
    }
     transition: all .3s;
     height: 360px;
     color:#fff;font-family: 'Alibaba-PuHuiTi-R';
     position: absolute;
     z-index:11;
     width: 100%;
     bottom:0px;

      background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
  }
   .ant-col-xl-5:nth-child(5) .item-industry,.ant-col-xl-5:nth-child(10) .item-industry{
    border-right:none
   }
  .ant-col-xl-5{
    width:20%; position: relative;
    cursor: pointer;

    .item-industry{
     text-align: center;
    line-height: 180px;
    transform: translateZ(0);
    transition: all .3s;
    img{
      width:60px;
      margin-right:25px;
    }
       height:180px;
        border-right:1px solid #D6EAFF;
        border-bottom:1px solid #D6EAFF;
    }

  }
  padding: 60px 0px;
}
</style>
